import styled from '@emotion/styled';
import { mainColors } from 'src/assets/colors';

export const SelectWrapper = styled('label', { label: 'SelectWrapper' })`
    display: flex;
    flex-direction: column;
    position: relative;
`;


export const Values = styled('div', { label: 'Values' })`
    font-size: 18px;
    height: 40px;
    box-sizing: border-box;
    padding: 0;
    border: solid 1px ${mainColors.grays.gray400};
    background-color: ${mainColors.default.light};
    display: flex;
`;

export const Value = styled('div', { label: 'Value' })`
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    padding: 5px;
    margin: 5px;
    border-radius: 3px;
    background-color: #dddddd;
    font-size: 13px;
    font-weight: 300;
`;

export const RemoveValue = styled('span', { label: 'RemoveValue' })`
    font-size: 22px;
    line-height: 0;
    margin-left: 5px;
`;

export const Options = styled('div', { label: 'Options' })<{hidden: boolean}>`
    display: ${({hidden}): string => hidden ? 'none' : 'block'};
    border: 1px solid #ddd;
    position: absolute;
    left: 0;
    top: 40px;
    width: 100%;
    height: 200px;
    z-index: 100;
    background: ${mainColors.default.light};
`;

export const Option = styled('div', { label: 'Option' })<{isSelected: boolean}>`
    width: 100%;
    padding: 10px;
    background: ${({isSelected}): string => isSelected ? '#ddd' : '#fff'};
    color: #666666;
    cursor: pointer;
    font-size: 18px;
`;

export const SelectElement = styled('select', { label: 'SelectElement' })`
    line-height: 30px;
    height: 32px;
    font-size: 14px;
    color: ${mainColors.default.dark};
    border: 1px solid ${mainColors.grays.gray400};
    box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, 0.5);
    background-color: transparent;
`;

export const SelectError = styled('div', { label: 'SelectError' })`
    flex: 1 0 100%;
    font-size: 12px;
    color: ${mainColors.status.error};
`;
